/**
 * 核心應用
 */
class CoreApp {
    constructor() {
        this.request = {
            method: { post: 'post', get: 'get', patch:'patch', put: 'put', delete: 'delete' },
            headers: {
                contentType: {
                    appJson: 'application/json;',
                    appJsonUtf8: 'application/json; charset=utf-8;',
                    appXWwwFormUrlEncoded: 'application/x-www-form-urlencoded;',
                    appXWwwFormUrlEncodedUtf8: 'application/x-www-form-urlencoded; charset=utf-8;',
                    multipartFormData: 'multipart/form-data',
                    textHtml: 'text/html;',
                    textHtmlUtf8: 'text/html; charset=utf-8;'
                },
            }
        }
    } 
}

export default CoreApp



// WEBPACK FOOTER //
// ./src/models/CoreApp.js